import { Button, Modal } from 'react-dsgov';
import { DiefCfemContext } from '../../../../../../../../../../../contexts/DiefCfemContext';
import { useNotificacao } from '../../../../../../../../../../../hooks/useNotificacao';
import { PaginasOutrosRegimes } from '../../../../../../../../../../../interfaces/IDadosOutrosRegimes';
import { IReceitaBrutaCalculadaNCMReceber } from '../../../../../../../../../../../interfaces/IReceitaBrutaCalculada';
import { useBackEndRequests } from '../../../../../../../../../lib/backEndRequests';
import style from './listaReceitaBrutaCalculada.module.scss';
import React, { useContext, useState } from 'react';
import { BrButton } from '@govbr-ds/react-components';
import ListaReceitaBrutaCalculadaItem from './listaReceitaBrutaCalculadaItem/listaReceitaBrutaCalculadaItem';
import { EMetodoReceitaBrutaCalculada } from '../../../../../../../../../../../enums/EMetodoBaseCalculo';
import CustomConfirmer from '../../../../../../../../../../../components/customConfirmer/customConfirmer';

interface IListaReceitaBrutaCalculadaProps {
  receitaBrutaCalculada: IReceitaBrutaCalculadaNCMReceber;
  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes>>;
  setIsEdicao: React.Dispatch<React.SetStateAction<boolean>>;
  refetchLista: () => void;
  refetchDados: () => void;
}

const ListaReceitaBrutaCalculada = ({
  receitaBrutaCalculada,
  setBaseDeCalculo,
  setIsEdicao,
  refetchLista,
  refetchDados,
}: IListaReceitaBrutaCalculadaProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [isModalOpened, setIsModalOpened] = useState(false);

  const context = useContext(DiefCfemContext);

  const { deleteReceitaBrutaCalculada } = useBackEndRequests();
  const mostrarNotificacao = useNotificacao();

  const editarReceitaBrutaCalculada = () => {
    context?.setIdReceitaBrutaCalculada(receitaBrutaCalculada?.id ?? -1);
    setIsEdicao(true);
    setBaseDeCalculo('receitaBrutaCalculada');
  };

  const deletarReceitaBrutaCalculada = async () => {
    await deleteReceitaBrutaCalculada(receitaBrutaCalculada?.id ?? -1)
      .then(() => {
        refetchLista();
        refetchDados();
        setIsModalOpened(false);
      })
      .catch((err) => {
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Erro ao deletar Receita Bruta, tente novamente.',
          ...(err && { complementoSentryId: err }),
        });
      });
  };

  return (
    <>
      <Modal title='Excluir Receita Bruta Calculada Selecionada' useScrim modalOpened={isModalOpened}>
        <Modal.Body>Deseja mesmo deletar a receita bruta calculada selecionada?</Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button secondary small m={2} onClick={() => setIsModalOpened(false)}>
            Cancelar
          </Button>
          <CustomConfirmer asyncCall={() => deletarReceitaBrutaCalculada()}>Confirmar</CustomConfirmer>
        </Modal.Footer>
      </Modal>
      <div
        data-testid='accordion-ncm'
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title} data-testid='titulo-ncm'>
            Receita Bruta Calculada
          </div>
        </div>
        <div className={style.rightContainer}>
          <BrButton
            data-testid='edit-button'
            circle
            size='small'
            icon='fas fa-edit fa-sm'
            onClick={() => editarReceitaBrutaCalculada()}
          />
          <BrButton
            data-testid='delete-button'
            circle
            size='small'
            icon='fas fa-trash fa-sm'
            onClick={() => setIsModalOpened(true)}
          />
        </div>
      </div>
      {isAccordionOpen && (
        <div className={style.accordionContent}>
          {receitaBrutaCalculada?.ncmsPrecoCorrente && receitaBrutaCalculada?.ncmsPrecoCorrente?.length > 0 && (
            <ListaReceitaBrutaCalculadaItem
              receitaBrutaCalculada={receitaBrutaCalculada?.ncmsPrecoCorrente}
              type={EMetodoReceitaBrutaCalculada.PRECO_CORRENTE}
            />
          )}
          {receitaBrutaCalculada?.ncmsValorReferencia && receitaBrutaCalculada?.ncmsValorReferencia?.length > 0 && (
            <ListaReceitaBrutaCalculadaItem
              receitaBrutaCalculada={receitaBrutaCalculada?.ncmsValorReferencia}
              type={EMetodoReceitaBrutaCalculada.VALOR_REFERENCIA}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ListaReceitaBrutaCalculada;
